// Splide
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export function splide() {
    if (document.querySelector('#featured')) {
        const featured = new Splide('#featured');
        featured.mount();
    }

    if (document.querySelector('#testimonials')) {
        const testimonials = new Splide('#testimonials');
        testimonials.mount();
    }

    if (document.querySelector('#clients')) {
        const clients = new Splide('#clients', {
            type: 'loop',
            autoWidth: true
        });
        clients.mount({ AutoScroll });
    }
}
